
import commonApi from "@/apis/common.api";
import realtimeApi from "@/apis/realtime.api";
import { $_DKD, $_WC } from "@/confs/common.const.js";

export default {
    state: {
        topMenuList: [
            {
                name: '다중밀집지역', code: 'Realcity',
                menuClass: ['sel_i11'],
                subMenuclass: ['mlc_item', 'mlc_item01'],
                subMenuName: ['재난안전 현황', '관련시설'],
                simplemapTitle: '재난안전 현황',
                simplemapUnit: '단위 : 건',
                seoulMapTitle: '자치구별 안전센터 현황',
                facClass: ['default_chk', 'cr1'],
                multiSub: false,
                borderColor: '#f15d5d',
                listTitle: '재난안전 발생 목록',
                chartTitle: '재난안전 발생 현황',
                chartIds: [936, 463, 464],
                chartTitles: ['시간별 재난발생 현황', '일별 재난발생 현황', '월별 재난발생 현황'],
            },
            {
                name: '재난안전', code: 'Safety',
                menuClass: ['sel_i06'],
                subMenuclass: ['mlc_item', 'mlc_item01'],
                subMenuName: ['재난안전 현황', '관련시설'],
                simplemapTitle: '재난안전 현황',
                simplemapUnit: '단위 : 건',
                seoulMapTitle: '자치구별 안전센터 현황',
                facClass: ['default_chk', 'cr1'],
                multiSub: true,
                borderColor: '#f15d5d',
                listTitle: '재난안전 발생 목록',
                chartTitle: '재난안전 발생 현황',
                chartIds: [936, 463, 464],
                chartTitles: ['시간별 재난발생 현황', '일별 재난발생 현황', '월별 재난발생 현황'],
            },
            {
                name: '도로교통', code: 'Accident',
                menuClass: ['sel_i07'],
                subMenuclass: ['mlc_item', 'mlc_item02'],
                subMenuName: ['도로교통 현황', '관련시설'],
                simplemapTitle: '도로교통 현황',
                simplemapUnit: '단위 : 건',
                seoulMapTitle: '자치구별 도로교통 현황',
                facClass: ['default_chk', 'cr2'],
                multiSub: true,
                borderColor: '#0086ed',
                listTitle: '도로교통 발생 목록',
                chartTitle: '도로교통 발생 현황',
                chartIds: [937, 461, 462],
                chartTitles: ['시간별 도로교통 발생 현황', '일별 도로교통 발생 현황', '월별 도로교통 발생 현황'],
            },
            {
                name: '대기환경', code: 'Air',
                menuClass: ['sel_i08'],
                subMenuclass: ['mlc_item', 'mlc_item03'],
                subMenuName: ['대기환경 현황', '관련시설'],
                simplemapTitle: '',
                simplemapUnit: '',
                seoulMapTitle: '자치구별 대기환경 현황',
                facClass: ['default_chk', 'cr3'],
                multiSub: false,
                borderColor: '#1bafbc',
                listTitle: '대기예보',
                chartTitle: '대기현황',
                chartIds: [458],
                chartTitles: ['시간별 대기현황'],
                // chartIds: [941, 466, 1057],
                // chartTitles: ['시간별 대기현황', '일별 대기현황', '월별 대기현황'],
            },
            {
                name: '상수도', code: 'Water',
                menuClass: ['sel_i09'],
                subMenuclass: ['mlc_item', 'mlc_item04'],
                subMenuName: ['상수도 현황', '관련시설'],
                simplemapTitle: '실시간 수질 현황',
                simplemapUnit: '',
                seoulMapTitle: '자치구별 상수도 현황',
                facClass: ['default_chk', 'cr4'],
                multiSub: false,
                borderColor: '#0049dd',
                listTitle: '상수도 상세정보',
                chartTitle: '수질현황',
                chartIds: [940, 468, 1056],
                chartTitles: ['시간별 수질현황', '일별 수질현황', '월별 수질현황'],
            },
            
        ],
        subMenuList: {
            'Realcity': [                
                {name: '종합안내', code: 'short', aClass: ['cur_ic51'], txtClass: 'txt', defaultChecked: true, subMenuMapUnit: ''},
                {name: '인구/행사', code: 'pop', aClass: ['cur_ic52'], txtClass: 'txt', defaultChecked: false, subMenuMapUnit: ''},
                {name: '도로소통', code: 'road', aClass: ['cur_ic53'], txtClass: 'txt', defaultChecked: false, subMenuMapUnit: ''},
                {name: '대중교통', code: 'sub', aClass: ['cur_ic54'], txtClass: 'txt', defaultChecked: false, subMenuMapUnit: ''},
                {name: '날씨/환경', code: 'weather', aClass: ['cur_ic55'], txtClass: 'txt', defaultChecked: false, subMenuMapUnit: ''},
                {name: '주차장 현황', code: 'pk', aClass: ['cur_ic56'], txtClass: 'txt', defaultChecked: false, subMenuMapUnit: ''},            
            ],
            'Safety': [
                {name: '재난', code: '0', aClass: ['cur_ic11'], txtClass: 'txt1', defaultChecked: true, subMenuMapCnt: 0, subMenuMapUnit: '건'},
                {name: '화재', code: '1', aClass: ['cur_ic12'], txtClass: 'txt1', defaultChecked: true, subMenuMapCnt: 0, subMenuMapUnit: '건'},
                {name: '구조', code: '2', aClass: ['cur_ic13'], txtClass: 'txt1', defaultChecked: true, subMenuMapCnt: 0, subMenuMapUnit: '건'},
                {name: '구급', code: '3', aClass: ['cur_ic14'], txtClass: 'txt1', defaultChecked: true, subMenuMapCnt: 0, subMenuMapUnit: '건'},
            ],
            'Accident': [
                {name: '사고', code: '1', aClass: ['cur_ic21'], txtClass: 'txt', defaultChecked: true, subMenuMapCnt: 0, subMenuMapUnit: '건'},
                {name: '공사', code: '2', aClass: ['cur_ic23'], txtClass: 'txt2', defaultChecked: true, subMenuMapCnt: 0, subMenuMapUnit: '건'},
                {name: '행사', code: '3', aClass: ['cur_ic22'], txtClass: 'txt1', defaultChecked: true, subMenuMapCnt: 0, subMenuMapUnit: '건'},
                {name: '통제', code: '5', aClass: ['cur_ic24'], txtClass: 'txt', defaultChecked: true, subMenuMapCnt: 0, subMenuMapUnit: '건'},
                {name: '건설', code: '1152', aClass: ['cur_ic27'], txtClass: 'txt', defaultChecked: false, subMenuMapCnt: 0, subMenuMapUnit: '건'},
            ],
            'Air': [
                {name: '미세먼지', code: 'pm10', aClass: ['cur_ic31'], txtClass: 'txt', defaultChecked: true, subMenuMapUnit: '건'},
                {name: '초미세먼지', code: 'pm25', aClass: ['cur_ic32'], txtClass: 'txt', defaultChecked: false, subMenuMapUnit: '건'},
                {name: '이산화질소', code: 'no2', aClass: ['cur_ic38'], txtClass: 'txt', defaultChecked: false, subMenuMapUnit: '건'},
                {name: '오존', code: 'o3', aClass: ['cur_ic37'], txtClass: 'txt', defaultChecked: false, subMenuMapUnit: '건'},
                // {name: '소음', code: 'decibel', aClass: ['cur_ic33'], txtClass: 'txt', defaultChecked: false, subMenuMapUnit: '건'},
                {name: '강우량  ', code: 'rain', aClass: ['cur_ic34'], txtClass: 'txt', defaultChecked: false, subMenuMapUnit: '건'},
                // {name: '매개모기', code: 'mediumMosq', aClass: ['cur_ic35'], txtClass: 'txt', defaultChecked: false, subMenuMapUnit: '마리'},
                // {name: '모기방역', code: 'mosquito', aClass: ['cur_ic35'], txtClass: 'txt', defaultChecked: false, subMenuMapCnt: 0, subMenuMapUnit: '건'},
            ],
            'Water': [
                {name: 'pH', code: 'val7', aClass: ['cur_ic41'], txtClass: 'txt', defaultChecked: true, subMenuMapUnit: 'pH'},
                {name: '잔류염소', code: 'val8', aClass: ['cur_ic41'], txtClass: 'txt', defaultChecked: false, subMenuMapUnit: 'mg/L'},
                {name: '탁도', code: 'val9', aClass: ['cur_ic41'], txtClass: 'txt', defaultChecked: false, subMenuMapUnit: 'NTU'},
                {name: '수온', code: 'val10', aClass: ['cur_ic41'], txtClass: 'txt', defaultChecked: false, subMenuMapUnit: '℃'},
            ],
        },
        facilitiesMenu: {
            'Safety': [
                {name: '소방시설', id: 'safetyCenter', isChecked: false, defaultChecked: false},
                {name: '의료시설', id: 'medicalFac', isChecked: false, defaultChecked: false},
                {name: '경찰서', id: 'police', isChecked: false, defaultChecked: false},
                {name: '경찰청CCTV', id: 'uticRoadCctv', isChecked: false, defaultChecked: false},
            ],
            'Accident': [
                {name: '교통상황', id: 'trafficState', isChecked: false, defaultChecked: false},
                {name: '경찰청CCTV', id: 'uticCctv', isChecked: false, defaultChecked: false},
            ],
            'Air': [
                // {name: '환경센서', id: 'envSensor', isChecked: false, defaultChecked: false},
                {name: '대기오염측정소', id: 'airPollution', isChecked: false, defaultChecked: false},
                {name: '폭염시설', id: 'heatWave', isChecked: false, defaultChecked: false},
            ],
            'Water': [
                {name: '수질측정소', id: 'reservoir', isChecked: false, defaultChecked: false},
            ],
            'Realcity': [
                {name: 'CCTV', id: 'realcityCctv', isChecked: false, defaultChecked: false},
            ],
        },
        isMenuOpen: $_WC.responsiveScale === 3 ? true : false,
        selectedTopMenu: '',
        selectedSubMenus: [],
        selectedFacilitiesMenus: [],
    },
    getters: {
        getIsMenuOpen(state) {
            return state.isMenuOpen;
        },
        getTopMenuList(state) {
            return state.topMenuList;
        },
        getSubMenuList(state) {
            return state.subMenuList;
        },
        getFacilitiesMenu(state) {
           return state.facilitiesMenu;
        },
        getSelectedTopMenu(state) {
            return state.selectedTopMenu;
        },
        getSelectedSubMenus(state) {
            return state.selectedSubMenus;
        },
        getSelectedFacilitiesMenus(state) {
            return state.selectedFacilitiesMenus;
        },
    },
    mutations: {
        IS_MENU_OPEN(state, isMenuOpen) {
            state.isMenuOpen = isMenuOpen;
        },
        SELECTED_TOP_MENU(state, selectedTopMenu) {
            state.selectedTopMenu = selectedTopMenu;
        },
        SELECTED_SUB_MENUS(state, selectedSubMenus) {
            state.selectedSubMenus = selectedSubMenus;
        },
        SELECTED_FACILITIES_MENUS(state, selectedFacilitiesMenus) {
            state.selectedFacilitiesMenus = selectedFacilitiesMenus;
        },
    },
    actions : {
        SET_IS_MENU_OPEN({commit}, isMenuOpen) {
            commit("IS_MENU_OPEN", isMenuOpen);
        },
        SET_SELECTED_TOP_MENU({commit}, selectedTopMenu) {
            commit("SELECTED_TOP_MENU", selectedTopMenu);
        },
        SET_SELECTED_SUB_MENUS({commit}, selectedSubMenus) {
            commit("SELECTED_SUB_MENUS", selectedSubMenus);
        },
        SET_SELECTED_FACILITIES_MENUS({commit}, selectedFacilitiesMenus) {
            commit("SELECTED_FACILITIES_MENUS", selectedFacilitiesMenus);
        },
    }
};
